<template>
    <div>
        <div slot="modal-body">
            <div v-if="showSuccess">
                <p>Saved hashtag set successfully</p>
            </div>
            <b-input-group size="md" v-if="showInput">
                <b-form-input
                    v-model="hashtagSetName"
                    placeholder="Type a name of new or existing hashtag set"
                    @input="showAutoComplete"
                ></b-form-input>
            </b-input-group>
            <div v-show="isAutoCompleteOpen" class="auto-complete">
                <ul class="autocomplete-results" v-for="suggestion in results" :key="suggestion.index">
                    <li
                        class="autocomplete-result"
                        @click="selectAutoComplete(suggestion)"
                    >{{suggestion}}</li>
                </ul>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 mt-3">
                <b-btn v-if="loading" variant="primary" disabled class="float-right">
                   Saving...
                </b-btn>
                <b-btn  v-else variant="primary" @click="saveHashtagSet" class="float-right">Save changes</b-btn>
                <b-btn variant="default" @click="hideModal" class="float-right">Close</b-btn>
        </div>
        <div v-if="showError">
            <b-alert
                show
                variant="danger"
                dismissible
            >Whoops, something went wrong. Please try again</b-alert>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import {api} from '../../_services/ritetag'

export default {
    name: 'SaveHashtagSet',
    props: [
        'hashtagSet',
        'modal'
    ],
    data() {
        return {
            hashtagSetName: '',
            showInput: true,
            showSuccess: false,
            showError: false,
            loading : false,
            isAutoCompleteOpen: false,
            results: []
        }
    },
    methods: {
        ...mapMutations([
            'toggleSaveHashtagSet'
        ]),
        saveHashtagSet() {
            this.loading = true
            var newhashtaglist = []
            console.log(this.hashtagSet)
           for(var i = 0; i < this.hashtagSet.length; i++){
               newhashtaglist.push(this.hashtagSet[i].text)
           }
            api.tagsetCreate({
                name: this.hashtagSetName,
                tags: newhashtaglist,
                merge: 1            }
            ).then((response) => {
                this.hashtagSetName = ''
                this.showSuccess = true
                this.loading = false;
                this.$notify({ type: 'success', text: 'Your tagset was saved successfully' })
                this.hideModal()
                this.showSuccess = false
            }).catch((err) => {
                this.$notify({ type: 'error', text: 'Oops! There was an error. Check your internet connection and refresh the page'})
                this.hideModal()
            })
        },
        showAutoComplete() {
            if (this.hashtagSetName.length > 0) {
                this.isAutoCompleteOpen = true
                this.results = this.getHashtagSetNames.filter(item => item.toLowerCase().indexOf(this.hashtagSetName.toLowerCase()) > -1);
            } else if (this.hashtagSetName.length === 0) {
                this.isAutoCompleteOpen = false
                this.results = undefined
            }
        },
        selectAutoComplete(selection) {
            this.hashtagSetName = selection
            this.saveHashtagSet()
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal1')
        }
    },
    computed: {
        ...mapGetters('hashtagSets',[
            'getSaveHashtagToggle',
            'getHashtagSets'
        ]),
        getHashtagSetNames: function () {
            let setNames = []
            for (let i = 0; i < this.getHashtagSets.length; i++) {
                setNames.push(this.getHashtagSets[i].name)
            }
            return setNames
        }
    }
}
</script>

<style scoped>
.btn {
    margin: 1px;
}
.auto-complete {
    position: relative;
    margin-right: 100px;
    margin-top: 5px;
}
.autocomplete-results {
    padding: 0;
    position: absolute;
    top: 93%;
    z-index: 100;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    overflow: auto;
    width: 175px;
    background-color: white;
    width: 250px !important;
    top: 75% !important;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
}

.autocomplete-result:hover {
    background-color: #c12f93;
    color: white;
}
</style>
